/**
 * SEC A: Seasonal events — PC arrow navigation
 * Mobile uses native swipe (no JS needed)
 */
(function () {
  const BREAKPOINT = 750;

  function init() {
    const wrapper = document.querySelector('.seasonal-events__scroll-wrapper');
    if (!wrapper) return;

    const track   = wrapper.querySelector('.seasonal-events__track');
    const prevBtn = wrapper.querySelector('.seasonal-events__arrow--prev');
    const nextBtn = wrapper.querySelector('.seasonal-events__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    // PC初期位置を先頭にリセット
    track.scrollLeft = 0;

    function getCardPositions() {
      // 各カードの左端位置を配列で返す
      const cards = track.querySelectorAll('.seasonal-events__card');
      const positions = [];
      cards.forEach(card => {
        positions.push(card.offsetLeft - track.offsetLeft);
      });
      return positions;
    }

    function getCurrentIndex(positions) {
      // 現在のスクロール位置に最も近いカードのインデックスを返す
      const current = track.scrollLeft;
      let closest = 0;
      let minDiff = Infinity;
      positions.forEach((pos, i) => {
        const diff = Math.abs(pos - current);
        if (diff < minDiff) {
          minDiff = diff;
          closest = i;
        }
      });
      return closest;
    }

    function updateArrows() {
      if (window.innerWidth < BREAKPOINT) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', () => {
      if (window.innerWidth < BREAKPOINT) return;
      const positions = getCardPositions();
      const currentIdx = getCurrentIndex(positions);
      // 3枚戻る（最小0）
      const targetIdx = Math.max(0, currentIdx - 3);
      track.scrollTo({ left: positions[targetIdx], behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      if (window.innerWidth < BREAKPOINT) return;
      const positions = getCardPositions();
      const currentIdx = getCurrentIndex(positions);
      // 3枚進む（最大=最後のカード）
      const targetIdx = Math.min(positions.length - 1, currentIdx + 3);
      track.scrollTo({ left: positions[targetIdx], behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    window.addEventListener('resize', () => {
      updateArrows();
      // リサイズ時に位置をリセット
      if (window.innerWidth >= BREAKPOINT) {
        track.scrollLeft = 0;
        updateArrows();
      }
    });

    // 初期状態を設定
    updateArrows();
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
